import {useNavigate} from 'react-router-dom'
import ReactHtmlParser from 'html-react-parser'
import { url } from '../Funciones'
import { useEffect } from 'react'
export default function LPS({subenlace,subenlace_en,imgs,texto}){
    const idioma=localStorage.getItem("idioma") || "es"
    const navigate=useNavigate()
    let array=idioma=="en"?subenlace_en.split(" "):subenlace.split(" ")
    let imagenes=Array.from({length:imgs.length},(_,i)=>(
        <img key={i} src={imgs[i]} style={{display:'block',width:'125px',height:'89px',margin:'0 auto',cursor:'pointer'}} onClick={()=>navigate("/productos-y-servicios/"+url(subenlace))}/>
    ))
    return(
        <div style={{margin:'1rem'}}>
            <h2 style={{textAlign:'center'}}><span>{array[0]}</span></h2>
            <h2 style={{textAlign:'center'}}>{idioma=="en"?subenlace_en.replace(array[0],""):subenlace.replace(array[0],"")}</h2>
            <a className='btn-form' href={'/productos-y-servicios/'+url(subenlace)} style={{display:'block',margin:'0 auto',width:'fit-content',color:'white'}}>+ Info</a>
            <div style={{margin:'1rem'}}>
                {imagenes}
            </div>
            <p>{ReactHtmlParser(texto)}</p>
        </div>
    )
}